<template>
  <div class="new-audit">
    <b-container fluid>
        <b-row>
            <b-col>
                <label for="facilityName-id">Facility Name</label>
            </b-col>
            <b-col>
                <b-form-input id="facilityName-id"
                    v-model="facilityName"
                    trim
                    required
                    type="text"
                    placeholder="Facility/Area Name"
                    :state="facilityNameState"
                    aria-describedby="facilityName-idFeedback"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col><label for="date-id">Date</label></b-col>
            <b-col>
                <b-form-input
                    id="date-id"
                    v-model="date"
                    type="date"
                    :state="dateState"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col><label >Director/Manager Name</label></b-col>
            <b-col>
                <b-form-input
                    v-model="mgrName"
                    placeholder="First Last..."
                />
            </b-col>
        </b-row>
        <b-row v-if="templateOptions.length > 1">
            <b-col><label >Template</label></b-col>
            <b-col>
                <b-form-select v-model="templateSelected" :options="templateOptions"></b-form-select>
            </b-col>
        </b-row>
    </b-container>
    <b-btn v-on:click="createAudit">Create Audit</b-btn>
  </div>
</template>


<script>

    import { API, graphqlOperation } from 'aws-amplify'
    import { listAuditTemplates } from '@/graphql/queries'
    import { v4 as uuidv4 } from 'uuid'

export const getChecklistTemplate1 = `query GetChecklistTemplate(
$id: ID!
) {
  getChecklistTemplate(
    id: $id
  ) {
    id
    auditCode
    desc
    questions {
      auditCode
      desc
    }
    sublists(limit:100) {
      items {
        id
        auditCode
        desc
      }
      nextToken
    }
  }
}
`;

export const getAuditTemplate1 = `query GetAuditTemplate(
$id: ID!
$limit: Int
$nextToken: String
) {
  getAuditTemplate(
    id: $id
  ) {
    id
    name
    desc
    checklists(limit:$limit, nextToken:$nextToken) {
      items {
        id
        auditCode
        desc
      }
      nextToken
    }
    owner
  }
}
`;

    async function loadTemplates() {
        let templates = []
        var nextToken, items
        do {
            ( { data: { listAuditTemplates: {items, nextToken} } } = await API.graphql(graphqlOperation(listAuditTemplates, {limit:100, nextToken})) )
            templates.push(...items)
        } while(nextToken)
        return templates;
    }

    export default {
        computed: {
            facilityNameState() {
                let result = false
                if (this.facilityName && this.facilityName.length > 0) {
                    result = true
                }
                return result
            },
            dateState() {
                let result = false
                if (this.date) {
                    result = true
                }
                return result
            },
        },
        data() {
            return {
                facilityName: "",
                date: "",
                mgrName: null,
                selectedChecklists: [],
                templateSelected: null,
                templateOptions: []
            }
        },
        methods: {
            async loadAuditTemplate(auditId) {
                try {
                    //let lists = []
                    //var nextToken, items
                    const { data: {getAuditTemplate: template} } = await API.graphql(graphqlOperation(getAuditTemplate1, {id: auditId}))
                    while(template.checklists.nextToken) {
                        const {  data: {getAuditTemplate: template2} } = await API.graphql(graphqlOperation(getAuditTemplate1,
                            {
                                id: auditId,
                                nextToken:template.checklists.nextToken}
                            ))
                        template.checklists.items.push(...template2.checklists.items)
                        template.checklists.nextToken = template2.checklists.nextToken
                    }
                    return template
                }
                catch (err) {
                    console.log('error getting audit template: ', err)
                }
            },
            async loadChecklistTemplate(id) {
                try {
                    //let lists = []
                    //var nextToken, items
                    const { data: {getChecklistTemplate: template} } = await API.graphql(graphqlOperation(getChecklistTemplate1, {id: id}))
                    while(template.sublists.nextToken) {
                        const {  data: {getChecklistTemplate: template2} } = await API.graphql(graphqlOperation(getChecklistTemplate1,
                            {
                                id: id,
                                nextToken:template.sublists.nextToken}
                            ))
                        template.sublists.items.push(...template2.sublists.items)
                        template.sublists.nextToken = template2.sublists.nextToken
                    }
                    return template
                }
                catch (err) {
                    console.log('error getting audit template: ', err)
                }
            },
            async createChecklistFromTemplate(id) {
                let checklistTemp = await this.loadChecklistTemplate(id)
                console.log("Creating checklist from template", checklistTemp)
                let sublistPromises = checklistTemp.sublists.items.map(s => this.createChecklistFromTemplate(s.id))
                let sublists = []
                for(var i = 0; i < sublistPromises.length; ++i) {
                    let sublist = await sublistPromises[i]
                    sublists.push(sublist)
                }
                console.log(checklistTemp)
                let checklist = {
                    id: uuidv4(),
                    auditCode: checklistTemp.auditCode,
                    desc: checklistTemp.desc,
                    questions: checklistTemp.questions.map(q => {
                        return {
                            id: uuidv4(),
                            auditCode: q.auditCode,
                            desc: q.desc
                        }
                    }),
                    sublists: sublists
                }
                return checklist
            },
            async createAudit() {
                if (this.facilityName === '' || this.date === '') {
                    return
                }
                const audit = {
                    id: uuidv4(),
                    facilityName: this.facilityName,
                    date: this.date,
                    mgrName: this.mgrName,
                    state: "inprogress",
                    lists:[]
                }

                if(this.templateSelected) {
                    let template = await this.loadAuditTemplate(this.templateSelected)
                    console.log("Retrieved template", template)

                    if(template.checklists) {
                        let checklistPromises = template.checklists.items.map(c => {
                            return this.createChecklistFromTemplate(c.id)
                        })
                        for( var i = 0; i < checklistPromises.length; ++i) {
                            let checklist = await checklistPromises[i]
                            audit.lists.push(checklist)
                        }
                    }
                }

                this.$emit('create-audit', audit)
                this.$store.dispatch('audits/newAudit', audit)

                this.$emit('create-audit', audit)

                // reset to initial state to make another audit
                this.facilityName = ''
                this.date = ''
                this.dirEmail = null
                this.dirPhone = null
                this.mgrEmail = null
                this.mgrPhone = null
                this.state = "inprogress"
            },
            validateEmail(email) {
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            },
            validatePhone(phone) {
                phone = phone.replace(/\s|-|\+|\(|\)/g, "")
                console.log("Stripped phone", phone)
                return phone.length >= 10 && phone.length <= 11
            }
        },
        async beforeMount() {
            console.log("**** beforeMount")

            try {
                const templates = await loadTemplates()
                console.log(templates)
                if(templates) {
                    let templateOptions = [{
                        text: 'none',
                        value: null
                    }]
                    templateOptions.push(...(templates.map(i => {
                        return {
                            text: i.name + ' ' + (i.desc ? i.desc : ''),
                            value: i.id
                        }
                    })))
                    this.templateOptions = templateOptions
                }
            }  catch (err) {
              console.log('error listing audits: ', err)
            }
        }
    }
</script>
